import { render, staticRenderFns } from "./TabBarIcon.vue?vue&type=template&id=7237f37b&scoped=true&"
import script from "./TabBarIcon.vue?vue&type=script&lang=js&"
export * from "./TabBarIcon.vue?vue&type=script&lang=js&"
import style0 from "./TabBarIcon.vue?vue&type=style&index=0&id=7237f37b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7237f37b",
  null
  
)

export default component.exports